import { render, staticRenderFns } from "./ProfileNavigationComponent.vue?vue&type=template&id=3830851f&"
import script from "./ProfileNavigationComponent.vue?vue&type=script&lang=js&"
export * from "./ProfileNavigationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports